module.exports = __webpack_public_path__ + "static/media/msa.0a53e398.jpeg";